export default "__VITE_ASSET__69727f72__"